import {
  ODataHeader,
  ODataString,
  ODataDecimal,
  ODataDateTime,
  ODataEnum,
} from "pbas-vue-components";

import { translate2 } from "../trans2";
import { translate3 } from "../trans3";
import { i18n } from "@/plugins/i18n";

const formatter = new Intl.NumberFormat("en-US", {
  style: "currency",
  currency: "USD",
  minimumFractionDigits: 2,
});
const storeHeaders = [
  new ODataHeader({
    type: new ODataString("Store/Id"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  // new ODataHeader({
  //   type: new ODataString("Store/Name"),
  //   visible: false,
  //   allowVisibilityChange: false,
  //   searchable: false,
  // }),
  new ODataHeader({
    type: new ODataString("Store/TranslationEffectives[]/LanguageCode"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    title: "globals.store",
    type: new ODataString("Store/TranslationEffectives[]/Name", {
      getString: (item) => translate3(item.Store, "Name"),
    }),
    sortable: false,
    visible: true,
    searchable: true,
  }),
];
const hoursHeader = new ODataHeader({
  title: "headers.hourshistory.hours",
  type: new ODataDecimal("Amount"),
  sortable: true,
  visible: true,
  searchable: true,
});
const dueHeaders = [
  new ODataHeader({
    type: new ODataString("Dues"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    title: "headers.employer_contributions_history.due",
    type: new ODataDecimal("ReportedAmount", {
      getString: (item) => {
        let value = item.Dues;
        if (value === null || value === undefined) {
          value = "";
        }
        if (typeof value === "number") {
          value = formatter.format(value);
        }
        return value;
      },
    }),
    sortable: true,
    visible: true,
    searchable: true,
  }),
];
const reportedHeaders = [
  new ODataHeader({
    type: new ODataString("Dues"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    title: "headers.employer_contributions_history.due_reported_amount",
    type: new ODataDecimal("ReportedAmount", {
      getString: (item) => {
        let value = item.Dues;
        let value2 = item.ReportedAmount;
        if (value === null || value === undefined) {
          value = "";
        }
        if (value2 === null || value2 === undefined) {
          value2 = "";
        }
        if (typeof value === "number") {
          value = formatter.format(value);
        }
        if (typeof value2 === "number") {
          value2 = formatter.format(value2);
        }
        return value + " / " + value2;
      },
    }),
    sortable: true,
    visible: true,
    searchable: true,
  }),
];
const headers1 = [
  new ODataHeader({
    title: "Id",
    type: new ODataString("Id"),
    visible: false,
    searchable: false,
    isIdentifier: true,
    allowVisibilityChange: false,
  }),
  new ODataHeader({
    type: new ODataString("Term/Id"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    type: new ODataString("Term/Name"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    type: new ODataString("Term/Translations[]/LanguageCode"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    title: "globals.term",
    type: new ODataString("Term/Translations[]/Name", {
      getString: (item) => translate2(item.Term, "Name"),
    }),
    sortable: true,
    visible: true,
    searchable: true,
    orderByKey: "Term/Name",
  }),
  new ODataHeader({
    type: new ODataString("Term/Year"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    title: "components.plancreationwizard.membereligibility.period",
    type: new ODataString("Term/Translations[]/Year"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
];
const headers2 = [
  new ODataHeader({
    title: "headers.employer_contributions_history.payment_amount",
    type: new ODataDecimal("PaymentAmount", {
      getString: (item) => {
        const value = item.PaymentAmount;
        if (value === null || value === undefined) {
          return "";
        }
        if (typeof value !== "number") {
          return value;
        }
        return formatter.format(value);
      },
    }),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new ODataHeader({
    title: "views.balancepayments.balance",
    type: new ODataDecimal("Balance", {
      getString: (item) => {
        const value = item.Balance;
        if (value === null || value === undefined) {
          return "";
        }
        if (typeof value !== "number") {
          return value;
        }
        return formatter.format(value);
      },
    }),
    sortable: true,
    visible: true,
    searchable: true,
  }),
];

function getHeaders(expand, hasLocations, hasContributions, enums) {
  const expandHeaders = [
    new ODataHeader({
      title: "Id",
      type: new ODataString("Id"),
      visible: false,
      searchable: false,
      isIdentifier: true,
      allowVisibilityChange: false,
    }),
    new ODataHeader({
      type: new ODataString("Term/Name"),
      visible: false,
      allowVisibilityChange: false,
      searchable: false,
    }),
    new ODataHeader({
      type: new ODataString("Term/Translations[]/LanguageCode"),
      visible: false,
      allowVisibilityChange: false,
      searchable: false,
    }),
    new ODataHeader({
      title: "components.plancreationwizard.membereligibility.period",
      type: new ODataString("Term/Translations[]/Name", {
        getString: (item) =>
          translate2(item.Term, "Name") + " " + translate2(item.Term, "Year"),
      }),
      sortable: true,
      visible: true,
      searchable: true,
      orderByKey: "Term/Name",
    }),
    // new ODataHeader({
    //   type: new ODataString("Term/Year"),
    //   visible: false,
    //   allowVisibilityChange: false,
    //   searchable: false,
    // }),
    // new ODataHeader({
    //   title: "components.plancreationwizard.membereligibility.period",
    //   type: new ODataString("Term/Translations[]/Year"),
    //   visible: false,
    //   allowVisibilityChange: false,
    //   searchable: false,
    // }),
    new ODataHeader({
      title: "globals.amount",
      type: new ODataDecimal("Amount", {
        getString: (item) => {
          let value = item.Amount;
          if (value === null || value === undefined) {
            value = "";
          }
          if (typeof value === "number") {
            value = formatter.format(value);
          }
          return value;
        },
      }),
      sortable: true,
      visible: true,
      searchable: true,
    }),
    new ODataHeader({
      title: "globals.reason",
      type: new ODataEnum("Reason", {
        getString: (item) => {
          return i18n.t("enums." + item.Reason);
        },
        dropdownItems: enums.ContributionType,
      }),
      sortable: true,
      visible: true,
      searchable: true,
    }),
    new ODataHeader({
      type: new ODataString("UserType"),
      sortable: true,
      visible: false,
      searchable: true,
      allowVisibilityChange: false,
    }),
    new ODataHeader({
      title: "globals.trigger",
      type: new ODataString("User", {
        getString: (item) => {
          return `${item.UserType} (${item.User})`;
        },
      }),
      sortable: true,
      searchable: true,
      visible: true,
    }),
    new ODataHeader({
      title: "globals.timestamp",
      type: new ODataDateTime("Timestamp"),
      sortable: true,
      visible: true,
      searchable: true,
      allowVisibilityChange: true,
    }),
  ];
  if (expand) {
    return expandHeaders;
  }
  let h = [].concat(headers1);
  console.log(
    "@@@@@@@@@@@@@@@@@@@",
    JSON.stringify(h),
    hasLocations,
    hasContributions
  );
  if (hasLocations) {
    h = h.concat(storeHeaders);
  }
  if (hasContributions) {
    h = h.concat([hoursHeader]);
  }
  if (hasContributions) {
    h = h.concat(reportedHeaders);
  } else {
    h = h.concat(dueHeaders);
  }
  h = h.concat(headers2);

  console.log("!!!!!!!!!!!!!!!!!!!!", JSON.stringify(h));
  return h;
}

export default getHeaders;
